import { Ident } from '@mode-switch/express';
export var Sort;
(function (Sort) {
    let Order;
    (function (Order) {
        Order["Ascending"] = "ASCENDING";
        Order["Descending"] = "DESCENDING";
    })(Order = Sort.Order || (Sort.Order = {}));
    let Type;
    (function (Type) {
        Type["Data"] = "DATA";
        Type["Alpha"] = "ALPHA";
        Type["ByField"] = "BY_FIELD";
        Type["ByNested"] = "BY_NESTED";
        Type["Manual"] = "MANUAL";
    })(Type = Sort.Type || (Sort.Type = {}));
    let ByData;
    (function (ByData) {
        function make(field, order = "ASCENDING") {
            return {
                field,
                order,
                type: "DATA",
            };
        }
        ByData.make = make;
    })(ByData = Sort.ByData || (Sort.ByData = {}));
    let ByAlpha;
    (function (ByAlpha) {
        function make(field, order = "ASCENDING") {
            return {
                type: "ALPHA",
                field,
                order,
            };
        }
        ByAlpha.make = make;
    })(ByAlpha = Sort.ByAlpha || (Sort.ByAlpha = {}));
    let ByField;
    (function (ByField) {
        function make(field, byField, order = "ASCENDING") {
            return {
                type: "BY_FIELD",
                field,
                byField,
                order,
            };
        }
        ByField.make = make;
    })(ByField = Sort.ByField || (Sort.ByField = {}));
    let ByNested;
    (function (ByNested) {
        function make(field, byField, order = "ASCENDING") {
            return {
                type: "BY_NESTED",
                field,
                byField,
                order,
            };
        }
        ByNested.make = make;
    })(ByNested = Sort.ByNested || (Sort.ByNested = {}));
    let ByManual;
    (function (ByManual) {
        function make(field, items, order = "ASCENDING") {
            const by = Ident.next('A');
            return {
                type: "MANUAL",
                field,
                by,
                items,
                order,
            };
        }
        ByManual.make = make;
    })(ByManual = Sort.ByManual || (Sort.ByManual = {}));
})(Sort || (Sort = {}));
